import {
  Configuration,
  LogLevel,
  PublicClientApplication,
  RedirectRequest,
} from "@azure/msal-browser";

const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${
      process.env.REACT_APP_ENTRA_TENANT_ID || ""
    }`,
    redirectUri: `${window.location.origin}/auth`,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) return;
        if (level === LogLevel.Error) {
          console.error(`[MSAL Error]: ${message}`);
        }
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest: RedirectRequest = {
  scopes: ["openid", "profile", "email"],
  prompt: "select_account",
};
